/** Whether Formik footer should offer Save and continue (3-button mode). */
export function shouldEnableFormikSaveBeforeLeave(
    enableSaveBeforeLeave: boolean | undefined,
    isNewRecord: boolean
): boolean {
    return enableSaveBeforeLeave === true && !isNewRecord;
}

/** Whether Cancel on a Formik edit footer should prompt before leaving. */
export function shouldGuardFormikCancel(
    enableUnsavedChangesGuard: boolean | undefined,
    dirty: boolean,
    readOnlyForm: boolean
): boolean {
    return enableUnsavedChangesGuard !== false && dirty && !readOnlyForm;
}

/** Footer uses the shared page guard when a provider is mounted. */
export function shouldDelegateCancelToSharedGuard(sharedGuardContextPresent: boolean): boolean {
    return sharedGuardContextPresent;
}
